module.exports = __webpack_public_path__ + "img/smiley_positive_ico.9da76382.png";